document.addEventListener("DOMContentLoaded", function () {
    new fullpage("#fullpage", {
        autoScrolling: !0,
        navigation: !0,
        scrollBar: !0,
        showActiveTooltip: !0,
        scrollOverflow: !0,
        afterRender: function () {
            document.body.style.overflow = "visible";
        },
    });
}),
    $(".home_banner_carousel").owlCarousel({ loop: !0, autoplay: !1, autoplayTimeout: 3e3, margin: 0, nav: !1, dots: !1, autoplayHoverPause: !1, responsive: { 0: { items: 1 }, 600: { items: 1 }, 1e3: { items: 1 } } }),
    $(".product_carousel").owlCarousel({ loop: !0, autoplay: !0, autoplayTimeout: 2e3, margin: 10, nav: !1, dots: !1, autoplayHoverPause: !0, responsive: { 0: { items: 1 }, 600: { items: 3 }, 1e3: { items: 4 } } }),
    $(".review_carousel").owlCarousel({ loop: !0, autoplay: !0, autoplayTimeout: 2e3, margin: 10, nav: !1, dots: !1, responsive: { 0: { items: 1 }, 600: { items: 2 }, 1e3: { items: 3 } } }),
    $(".blogs_carousel").owlCarousel({ loop: !0, autoplay: !1, autoplayTimeout: 2e3, margin: 10, nav: !1, dots: !1, responsive: { 0: { items: 1 }, 600: { items: 2 }, 1e3: { items: 3 } } }),
    $(".collection_carousel").owlCarousel({ loop: !0, autoplay: !0, autoplayTimeout: 2e3, margin: 10, nav: !1, dots: !1, responsive: { 0: { items: 1 }, 600: { items: 2 }, 1e3: { items: 3 } } }),
    $(document).ready(function () {
        var owl = $(".owl-carousel");
        owl.owlCarousel({}),
            setTimeout(function () {
                owl.trigger("refresh.owl.carousel");
            }, 300);
    });
//# sourceMappingURL=/s/files/1/0562/8215/3059/t/4/assets/custom-script.js.map?v=1749122627
